import { Status } from '@vendasta/sales-orders';

export function IsOrderStatus(statusOrString: Status | string): statusOrString is Status {
  return typeof statusOrString !== 'string';
}
